import badgeRecipe from './Badge.recipe';
import buttonRecipe from './Button.recipe';
import closeButtonRecipe from './CloseButton.recipe';
import colorButtonRecipe from './ColorButton.recipe';
import controlButtonRecipe from './ControlButton.recipe';
import definitionTooltipRecipe from './DefinitionTooltip.recipe';
import iconRecipe from './Icon.recipe';
import inputRecipe from './Input.recipe';
import inputAddonRecipe from './InputAddon.recipe';
import linkRecipe from './Link.recipe';
import linkButtonRecipe from './LinkButton.recipe';
import selectableTagRecipe from './SelectableTag.recipe';
import separatorRecipe from './Separator.recipe';
import skeletonRecipe from './Skeleton.recipe';
import spinnerRecipe from './Spinner.recipe';
import textareaRecipe from './Textarea.recipe';
import toggleButtonRecipe from './ToggleButton.recipe';

const recipes = {
  badge: badgeRecipe,
  button: buttonRecipe,
  closeButton: closeButtonRecipe,
  controlButton: controlButtonRecipe,
  colorButton: colorButtonRecipe,
  definitionTooltip: definitionTooltipRecipe,
  icon: iconRecipe,
  input: inputRecipe,
  inputAddon: inputAddonRecipe,
  link: linkRecipe,
  linkButton: linkButtonRecipe,
  selectableTag: selectableTagRecipe,
  separator: separatorRecipe,
  skeleton: skeletonRecipe,
  spinner: spinnerRecipe,
  textarea: textareaRecipe,
  toggleButton: toggleButtonRecipe,
};

export default recipes;
